package com.ijoin.ui.util

import com.ijoin.data.model.MoneyAmount
import kotlin.math.abs
import kotlin.math.roundToLong

fun MoneyAmount.format(): String = formatMoney(value, currency)

fun MoneyAmount?.formatOrPlaceholder(placeholder: String = "--"): String =
    this?.format() ?: placeholder

fun formatMoney(amount: Double, currency: String?): String {
    val scaled = (abs(amount) * 100).roundToLong()
    val whole = scaled / 100
    val fraction = (scaled % 100).toInt()
    val prefix = if (amount < 0) "-" else ""
    val wholeText = formatWithGrouping(whole)
    val fractionText = fraction.toString().padStart(2, '0')
    val symbol = currencySymbol(currency)
    return buildString {
        append(prefix)
        append(symbol)
        append(wholeText)
        append('.')
        append(fractionText)
    }
}

private fun formatWithGrouping(value: Long): String {
    val digits = value.toString()
    if (digits.length <= 3) return digits
    val builder = StringBuilder()
    digits.forEachIndexed { index, char ->
        builder.append(char)
        val remaining = digits.length - index - 1
        if (remaining > 0 && remaining % 3 == 0) {
            builder.append(' ')
        }
    }
    return builder.toString()
}

private fun currencySymbol(currency: String?): String {
    val normalized = currency?.uppercase()?.trim().orEmpty()
    return when (normalized) {
        "USD" -> "$"
        "EUR" -> "EUR "
        "RUB", "RUR" -> "RUB "
        "" -> ""
        else -> "$normalized "
    }
}
